import { useCallback } from 'react';
import { CellValueChangedEvent } from 'ag-grid-community';
import { showWarning } from 'src/utils/toast/toastUtil';

import { SYS2010_R01Dto } from '../Dto_SYS2010_R01';

interface UseSYS2010_R01CellChangeProps {
	updateSYS2010_R01List: (index: number, data: SYS2010_R01Dto) => void;
	originalSYS2010_R01List: SYS2010_R01Dto[];
	defaultSYS2010_R01Row: SYS2010_R01Dto;
}

export function useSYS2010_R01CellChange({
	updateSYS2010_R01List,
	originalSYS2010_R01List,
	defaultSYS2010_R01Row,
}: UseSYS2010_R01CellChangeProps) {
	const handleCellChange = useCallback((event: CellValueChangedEvent<SYS2010_R01Dto>) => {
		const { data, colDef, newValue } = event;
		if (!data || !colDef.field) return;
		const field = colDef.field as keyof SYS2010_R01Dto;

		const updatedData: SYS2010_R01Dto = {
			...data,
			[field]: newValue as any,
			isModified: !data.inserted,
		};

		if (field === 'manualPage') {
			const parsed = Number(newValue ?? updatedData.manualPage ?? defaultSYS2010_R01Row.manualPage);
			if (Number.isNaN(parsed)) {
				showWarning('숫자를 입력해주세요.');
				updatedData.manualPage = data.manualPage ?? defaultSYS2010_R01Row.manualPage;
			} else if (parsed < 1) {
				showWarning('1 이상의 숫자를 입력해주세요.');
				updatedData.manualPage = 1;
			} else {
				updatedData.manualPage = Math.trunc(parsed);
			}
		}

		const originalRow = originalSYS2010_R01List.find((item) => item.valueIndex === data.valueIndex);
		if (originalRow && originalRow[field] === updatedData[field]) {
			updatedData.isModified = false;
		}

		updateSYS2010_R01List(data.valueIndex!, updatedData);
	}, [updateSYS2010_R01List, originalSYS2010_R01List, defaultSYS2010_R01Row]);

	return { handleCellChange };
}
